import { TCalendarType } from '@/pages/Calendar/calendar.types'
import { useState, RefObject, useLayoutEffect, useCallback } from 'react'

export type TReportViewingMode = Extract<TCalendarType, 'twoWeek' | 'fourWeek'>

const useReportLayout = (ref: RefObject<HTMLElement>, rowsNum: number, brakePoint: number) => {
  const [scrollbarWidth, setScrollbarWidth] = useState(0)
  const [viewingMode, setViewingMode] = useState<TReportViewingMode>('fourWeek')

  const update = useCallback(() => {
    if (!ref.current) return

    const scrollWidth = ref.current.offsetWidth - ref.current.clientWidth
    setScrollbarWidth(scrollWidth > 0 ? scrollWidth : 0)
    setViewingMode(window.innerWidth > brakePoint ? 'fourWeek' : 'twoWeek')
  }, [ref])

  useLayoutEffect(() => {
    const observer = new ResizeObserver(update)
    if (ref.current) observer.observe(ref.current)
    return () => observer.disconnect()
  }, [ref, rowsNum])

  return {
    scrollbarWidth,
    viewingMode,
  }
}

export default useReportLayout
